import { IsInt } from 'class-validator';

export class OrderDeleteRequest {
    @IsInt()
    public id: number;

    constructor(data?: Partial<OrderDeleteRequest>) {
        this.id = data?.id;
    }
}
